<template>
  <v-dialog v-model="show" class="modal" persistent max-width="739px" scrollable>
    <v-card style="align-items: baseline; overflow-y: auto; padding: 0px 32px">
      <v-form style="width: 100%" @submit.prevent="submitForm">
        <v-container class="form-conainer">
          <v-layout align-center>
            <v-flex>
              <v-card-title primary-title class="pl-0">
                <span class="dialog-title attendee-field-title"> Prijavi se ovdje </span>
              </v-card-title>
            </v-flex>
            <v-flex style="text-align: end">
              <v-btn icon @click="closeDialog" id="clear">
                <v-icon>clear</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <login-form :vs="$v" :initial-values="{}" @values="form = $event" />
        </v-container>
        <v-card-actions class="btn-row">
          <main-button
            id="login"
            depressed
            class="action-button btn-signin"
            text="Prijava"
            type="submit"
          />
          <main-button
            id="password-forgot"
            :uppercase="false"
            flat
            class="action-button password-forgot"
            text="Zaboravljena lozinka?"
            target="_blank"
            @click.prevent="handleForgotPassword()"
          />
        </v-card-actions>
      </v-form>
    </v-card>
    <simple-snackbar v-bind.sync="snackbar" />
  </v-dialog>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators'
import LoginForm from '../../user/login-form.vue'
import { submitGuard } from '../../../utils'
import { LOGIN } from '../../../graphql/auth.graphql'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'

export default {
  name: 'quick-signup-dialog',
  components: {
    SimpleSnackbar,
    LoginForm,
  },
  props: {
    show: Boolean,
  },
  validations() {
    return {
      form: {
        email: { required, email },
        password: { required },
      },
    }
  },
  data() {
    return {
      snackbar: {},
      form: {},
    }
  },

  methods: {
    async submitForm() {
      await submitGuard(this, async () => {
        const { data, errors } = await this.$apollo.mutate({
          mutation: LOGIN,
          variables: this.form,
        })
        if (errors) {
          this.snackbar = {
            open: true,
            messageProp: errors[0].message,
            color: 'error',
          }
        } else if (data.login) {
          this.$emit('success')
          this.closeDialog()
        } else {
          this.snackbar = {
            open: true,
            messageProp: 'Wrong username or password',
            color: 'error',
          }
        }
      })
    },
    closeDialog() {
      this.$v.$reset()
      this.$emit('update:show', false)
    },
    handleForgotPassword() {
      let routeData = this.$router.resolve({ name: this.routes.shared.forgotPassword })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style scoped>
.action-button {
  /* width: 94px !important; */
  height: 36px !important;
}

.form-conainer {
  padding: 0px;
}

.dialog-title {
  font-family: Raleway, 'sans-serif';
  color: #0277bd;
  font-size: 24px;
  text-transform: unset;
}

.btn-row {
  padding: 0;
  justify-content: space-between;
  padding-bottom: 24px;
}

.password-forgot {
  display: flex;
  align-self: flex-end;
  margin-left: 32px;
}
</style>
